import cardSnapSrc from '../assets/tablesounds/card_snap.wav';
import foldSwooshSrc from '../assets/tablesounds/fold_swoosh.wav';
import turnStartSrc from '../assets/tablesounds/turn_start.wav';
import chipsSmallSrc from '../assets/tablesounds/chips_small.wav';
import chipsMedSrc from '../assets/tablesounds/chips_med.wav';
import chipsMed2Src from '../assets/tablesounds/chips_med2.wav';
import chipsBigSrc from '../assets/tablesounds/chips_big.wav';
import reserveTimeSrc from '../assets/tablesounds/ReserveTime_notification.wav';
import winningBellSrc from '../assets/tablesounds/winning_bell.wav';
import freezeSrc from '../assets/tablesounds/freeze_sound.wav';

// Master volume (0..1) applied on top of each sound's own base level. Persisted in
// localStorage so the Settings → Volume slider survives reloads.
let masterVolume = parseFloat(localStorage.getItem("masterVolume"));
if (Number.isNaN(masterVolume)) masterVolume = 1;

let muted = localStorage.getItem("muted") === "true";

// The level actually applied to playback: 0 when muted, otherwise the master volume.
const effectiveVolume = () => (muted ? 0 : masterVolume);

export const getMasterVolume = () => masterVolume;

export const setMasterVolume = (value) => {
  masterVolume = Math.min(1, Math.max(0, value));
  localStorage.setItem("masterVolume", String(masterVolume));
};

export const getMuted = () => muted;

export const setMuted = (value) => {
  muted = !!value;
  localStorage.setItem("muted", String(muted));
};

const cardSnapAudio = new Audio(cardSnapSrc);
const foldSwooshAudio = new Audio(foldSwooshSrc);
const turnStartAudio = new Audio(turnStartSrc);
const chipsSmallAudio = new Audio(chipsSmallSrc);
const chipsMedAudio = new Audio(chipsMedSrc);
const chipsMed2Audio = new Audio(chipsMed2Src);
const chipsBigAudio = new Audio(chipsBigSrc);
const reserveTimeAudio = new Audio(reserveTimeSrc);
const winningBellAudio = new Audio(winningBellSrc);
const freezeAudio = new Audio(freezeSrc);

export const playCardSnap = () => {
  const sound = cardSnapAudio.cloneNode();
  sound.volume = 0.6 * effectiveVolume();
  sound.play().catch(() => {});
};

export const playFoldSwoosh = () => {
  const sound = foldSwooshAudio.cloneNode();
  sound.volume = 0.6 * effectiveVolume();
  sound.play().catch(() => {});
};

export const playTurnStart = () => {
  const sound = turnStartAudio.cloneNode();
  sound.volume = 0.6 * effectiveVolume();
  sound.play().catch(() => {});
};

// Chip sounds: small = bet/call placed, med = big raise, med2 = bets collected
// into the pot, big = pot awarded to the winner.
export const playChipsSmall = () => {
  const sound = chipsSmallAudio.cloneNode();
  sound.volume = 0.6 * effectiveVolume();
  sound.play().catch(() => {});
};

export const playChipsMed = () => {
  const sound = chipsMedAudio.cloneNode();
  sound.volume = 0.6 * effectiveVolume();
  sound.play().catch(() => {});
};

export const playChipsMed2 = () => {
  const sound = chipsMed2Audio.cloneNode();
  sound.volume = 0.6 * effectiveVolume();
  sound.play().catch(() => {});
};

export const playChipsBig = () => {
  const sound = chipsBigAudio.cloneNode();
  sound.volume = 0.6 * effectiveVolume();
  sound.play().catch(() => {});
};

// Plays for the acting user only when their default time bank runs out and the timer
// flips to the (red) reserve time bank.
export const playReserveTime = () => {
  const sound = reserveTimeAudio.cloneNode();
  sound.volume = 0.6 * effectiveVolume();
  sound.play().catch(() => {});
};

// Plays when the pot is awarded to the winner(s) at the end of a round.
export const playWinningBell = () => {
  const sound = winningBellAudio.cloneNode();
  sound.volume = 0.6 * effectiveVolume();
  sound.play().catch(() => {});
};

// Plays room-wide on every freeze-time start (FREEZE_STARTED — an active Freeze press
// or a queued freeze firing at its stage/phase point).
export const playFreeze = () => {
  const sound = freezeAudio.cloneNode();
  sound.volume = 0.6 * effectiveVolume();
  sound.play().catch(() => {});
};
